// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261100/js/" + chunkId + "." + {"44":"cbf1d60f","225":"10ee911a","481":"7f501552","486":"36281a1a","770":"0b2e37f9"}[chunkId] + ".0.4566073314436724.chunk.js";
};